import { Dropdown } from "capitalrx-components-2.0/lib/forms";
import styled from "styled-components";

const TextDropdown = styled(Dropdown)`
  font-size: 15px;
  line-height: 20px;
  font-weight: 600;

  & div {
    border: none;
    padding: 0;
  }

  & .icon.arrow > .icon-container svg path {
    fill: #313E48 !important;
  }

  & .focused:not(.readonly) {
    box-shadow: none;
  }
`;

export default TextDropdown;
